<template xmlns:v-b-popover="http://www.w3.org/1999/xhtml">
  <div>
    <h4 class="text-center">Viber Bot</h4>
    <div class="mt-5">
      <form @submit.prevent="promiseConnectAccessToken = connectViber()">

        <div class="form-group row mt-3">
          <label class="col-4 text-muted col-form-label">
            App Key:
            <span id="secret_app_key_info" v-b-popover:secret_app_key_info.html.hover.right="popoverText">
              <icon name="info-circle"></icon>
            </span>
          </label>
          <div class="col-8">
            <input class="form-control"
                   :class="{'is-invalid': isAccessTokenInvalid || serverErrorMessage}"
                   v-model="accessToken"/>
            <div v-show="isAccessTokenInvalid" class="invalid-feedback">
              Please provide an Access Token.
            </div>
            <div v-show="serverErrorMessage" class="invalid-feedback">
              {{ serverErrorMessage }}
            </div>
          </div>
        </div>

        <div class="alert alert-warning">
          Don’t have a Viber Bot account?
          Check <a href="https://docs.amio.io/docs/viber-setup" target="_blank">documentation</a>
          to see how to create one.
        </div>
        <div class="row mt-5">
          <div class="col-12 d-flex justify-content-center">
            <button class="btn btn-primary px-5"
                    v-busy-button="promiseConnectAccessToken">
              Connect
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import channelService from '@/services/amio-api/channel.service'
  import 'vue-awesome/icons/info-circle'

  const popoverText = 'Viber public account app key is a secret key you ' +
    '<a href="https://docs.amio.io/docs/viber-connect-viber-public-account" target="_blank">receive from Viber.</a>'

  export default {
    data() {
      return {
        promiseConnectAccessToken: null,
        popoverText,
        isAccessTokenInvalid: false,
        accessToken: '',
        serverErrorMessage: ''
      }
    },

    methods: {
      connectViber() {
        this.clearError()
        if (!this.accessToken) {
          this.isAccessTokenInvalid = true
          return
        }

        this.isAccessTokenInvalid = false
        const data = {
          type: 'viber',
          viber: {
            access_token: this.accessToken
          }
        }
        return channelService.create(data, [422])
          .then(channel => {
            this.channel = channel
            this.$router.push({name: 'administration.channel-detail.info', params: {id: channel.id}})
          })
          .catch((err) => {
            if (err.response.status !== 422) return

            const error = err.response.data.errors ? err.response.data.errors[0] : {}
            return this.handleError(error)
          })
          .then(() => {
            this.promiseConnectAccessToken = null
          })
      },

      clearError() {
        this.serverErrorMessage = ''
      },

      handleError(error) {
        this.serverErrorMessage = error.message
      }
    }
  }
</script>
